<section class="fancy-h1" *ngIf="title">
  <div class="container">
    <h1>{{ title }}</h1>
  </div>
</section>
